import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  a {
    font-family: DM Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #4339F2;
    text-decoration: none;
  }

  body {
    background-color: var(--color-background);
    color: ${(props) => props.theme.colors.text};
    font-family: DM Sans;
  }

  pre {
    font-family: DM Sans;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  }


  h1 {
    font-family: DM Sans;
    font-style: normal;
    font-weight: 700;
    font-size: 30px;
    line-height: 32px;
  }

  h2 {
    font-family: DM Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 22px;
  }

  h3 {
    font-family: DM Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;

  }

  h4 {
    font-family: DM Sans;
    font-style: normal;
    font-size: 14px;
    font-weight: 500;
    line-height: 14px;
    margin-bottom: 0px;
  }

  h5 {
    font-family: DM Sans;
    font-style: normal;
    font-weight: 500;
    font-size:12px;
    line-height: 15px;
    margin-bottom: 0px;
  }

  h6 {
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 15px;
  }

  textarea {
    width: 100%;
    resize: none;
    font-family: 'DM Sans';
    padding: 18px 24px;
    outline: none;
    border: none;
    background-color: var(--color-gray);
    border-radius: 10px;
  }


  select {
    -webkit-appearance: none; 
    appearance: auto;
  }

  input {
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    
  }

/* width */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: lightgray;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #3D2B5166;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #3D2B51;
}

  :root {
    --color-background: #EDEDED;
    --color-white: #FFF;
    --color-black: #000;
    --color-orange-opaque: #EA3B4499;
    --color-green-opaque: #2DD88199;
    --color-blue: #6fc0dc;  
    --color-blue-10: #6fc0dc1A; 
    --color-login-input: #F8F8F8; 
    --color-brown: #663E33;
    --color-purple: #47366C;
    --color-yellow: #e8b63a;
    --color-gray: #F8F8F8;
    --color-green: #34B53A;
    --color-green-success: #E2FBD7;
    --color-red: #FF3A29;
    --color-input: #c2d6c9;
    --color-light-red: #FFB9B2;
    --color-light-green: #C4EEC6;
    --color-orange: #EA3B44;
    --color-lever: #C5095A;
    --color-white-opaque: #FFFFFF66;
    --color-ford-gray: #979797;

  }
`
